export default "__VITE_ASSET__D1ch6Hy9__"